import { ReactComponent as SimeraBlackLogo } from '$icons/simera-dark logo.svg';
import { useState } from 'react';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';

const SPKShareHeader = () => {
  const [isOpenContactTeam, setIsOpenContactTeam] = useState(false);

  return (
    <nav className="flex justify-between py-4 bg-white mb-4">
      <ModalInTailwind
        isOpen={isOpenContactTeam}
        closeModal={() => {
          setIsOpenContactTeam(false);
        }}
      >
        <div className="bg-white rounded-xl w-11/12 h-5/6">
          <iframe
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ1FNPK_tAZ4lUOMUCuyh-h5LrYvqxdkScapFbyzrMLdOgqmmTNY6KIQ3Ow7VsNbl38n-qD1YWGa?gv=true"
            className="w-full h-full"
            title="Calendar"
          />
        </div>
      </ModalInTailwind>
      <div className="container flex flex-row m-auto">
        <div className="w-full flex items-center gap-4">
          <SimeraBlackLogo className="w-24" />
          <div className="bg-[#BFEFEC] font-semibold px-2 text-sm rounded text-[#016F68]">
            Shortlist
          </div>
        </div>

        <button
          type="button"
          className="text-spk-brightBlue bg-spk-brightBlue/10 text-nowrap px-6 py-2 rounded-full text-sm font-semibold"
          onClick={() => setIsOpenContactTeam(true)}
        >
          Talk to the Team
        </button>
      </div>
    </nav>
  );
};

export default SPKShareHeader;
